<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="repairRegistrations/sc"
        @delete="deleteHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="工单号">
            <el-input v-model.trim="filter.productionNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="条形码">
            <el-input v-model.trim="filter.barcode" placeholder="请输入条形码" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="已报修" :value="1"/>
              <el-option label="已修" :value="2"/>
              <el-option label="疑难杂症" :value="3"/>
              <el-option label="报废" :value="4"/>
              <el-option label="可用" :value="5"/>
              <el-option label="不可用" :value="6"/>
            </el-select>
          </el-form-item>
          <el-form-item label="报修日期">
            <el-date-picker
                v-model="faultTimeDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="faultTimeChange"
            />
          </el-form-item>
          <el-form-item label="维修日期">
            <el-date-picker
                v-model="repairTimeDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="repairTimeDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  export default {
    name: "RepairRegistrationList",
    components: {viewTable},
    data() {
      return {
        limits: {
          delAuth: this.$auth(615),
        },
        submitLoading: false,
        receiveTimeRange: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        faultTimeDate: "",
        repairTimeDate: "",
        filter: {
          billNo: "",
          productionNo: "",
          materialNo: "",
          materialName: "",
          barcode: "",
          beginCreateTime: "",
          endCreateTime: "",
          faultTimeStartTime: "",
          faultTimeEndTime: "",
          repairTimeStartTime: "",
          repairTimeEndTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: 1,
          type: 20,
          receiveTimeBegin: "",
          receiveTimeEnd: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            align: "center",
            width: 220,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/RepairRegistrationSCPreview",
                        query: {
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "statusName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "materialNo",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "materialName",
            align: "center",
            width: 220,
          },
          {
            tooltip: true,
            key: "typeName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "receiveName",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "repairName",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "barcode",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "receiveTime",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "hardwareVersion",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "softwareVersion",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "historicalAlarms",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "faultReporting",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "faultActual",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.repairRegistrationEdit.open(row);
      },
      faultTimeChange(date) {
        if (date) {
          this.filter.faultTimeStartTime = date[0];
          this.filter.faultTimeEndTime = date[1];
        } else {
          this.filter.faultTimeStartTime = "";
          this.filter.faultTimeEndTime = "";
        }
      },
      repairTimeDateChange(date) {
        if (date) {
          this.filter.repairTimeStartTime = date[0];
          this.filter.repairTimeEndTime = date[1];
        } else {
          this.filter.handleTimeBegin = "";
          this.filter.handleTimeEnd = "";
        }
      },
      printHandle() {
        // 返修品发货单
        // const path = "/returnMerchandiseDeliveryNotePrint";
        const path = "/productRepairListPrint";
        const routeUrl = this.$router.resolve({
          path: path,
          query: {
            params: JSON.stringify(this.selection[0]),
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "repairRegistrations/deleteBySC", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      otherAuth(row) {
        return row.status !== 1;
      },
    },
  };
</script>
